import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { roleConfig } from '../config/roleConfig';

/**
 * RoleGuard - Protects routes based on user roles
 * @param {Array} allowedRoles - Array of roles that can access this route
 * @param {ReactNode} children - Component to render if authorized
 * @param {string} fallbackPath - Where to redirect if unauthorized (default: role's own defaultRoute)
 */
const RoleGuard = ({ allowedRoles = [], children, fallbackPath }) => {
  const { user, isAuthenticated, loading } = useContext(AuthContext);
  const location = useLocation();

  // Show loading while checking auth
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        direction: 'rtl'
      }}>
        <div>جاري التحقق من الصلاحيات...</div>
      </div>
    );
  }

  // Not authenticated at all
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has required role
  if (!allowedRoles.includes(user?.role)) {
    // Use explicit fallback, or the role's own default route from config
    const destination = fallbackPath || roleConfig[user?.role]?.defaultRoute || '/login';
    // Safety: don't redirect to the same path (infinite loop prevention)
    if (destination === location.pathname) {
      return <Navigate to="/login" replace />;
    }
    return <Navigate to={destination} replace />;
  }

  // User has required role
  return children;
};

export default RoleGuard;